<script setup>
const props = defineProps({
  tag: {
    type: String,
    default: 'div'
  },
  name: {
    type: [String, Number],
    required: true
  }
})

const { handleItemClick, activeNames } = inject('collapse')

const isActive = computed(() => {
  return Array.isArray(activeNames.value)
    ? activeNames.value.includes(props.name)
    : activeNames.value === props.name
})
</script>

<template>
  <component
    :is="tag"
    class="collapse-trigger"
    @click="handleItemClick(name)"
  >
    <slot :is-active="isActive" />
  </component>
</template>

<style lang="less">
.collapse-trigger {
  cursor: pointer;
}
</style>
